__turbopack_context__.v({
  "arrowIcon": "ExploreRelatedProg-module-scss-module__D5qd8a__arrowIcon",
  "card": "ExploreRelatedProg-module-scss-module__D5qd8a__card",
  "cardBody": "ExploreRelatedProg-module-scss-module__D5qd8a__cardBody",
  "cardDescription": "ExploreRelatedProg-module-scss-module__D5qd8a__cardDescription",
  "cardImageWrapper": "ExploreRelatedProg-module-scss-module__D5qd8a__cardImageWrapper",
  "cardSubTitle": "ExploreRelatedProg-module-scss-module__D5qd8a__cardSubTitle",
  "cardText": "ExploreRelatedProg-module-scss-module__D5qd8a__cardText",
  "cardTitle": "ExploreRelatedProg-module-scss-module__D5qd8a__cardTitle",
  "cardsCarousel": "ExploreRelatedProg-module-scss-module__D5qd8a__cardsCarousel",
  "careersCarouselWrapper": "ExploreRelatedProg-module-scss-module__D5qd8a__careersCarouselWrapper",
  "ctaButton": "ExploreRelatedProg-module-scss-module__D5qd8a__ctaButton",
  "ctaIcon": "ExploreRelatedProg-module-scss-module__D5qd8a__ctaIcon",
  "ctaWrapper": "ExploreRelatedProg-module-scss-module__D5qd8a__ctaWrapper",
  "header": "ExploreRelatedProg-module-scss-module__D5qd8a__header",
  "learnMore": "ExploreRelatedProg-module-scss-module__D5qd8a__learnMore",
  "section": "ExploreRelatedProg-module-scss-module__D5qd8a__section",
  "subtitle": "ExploreRelatedProg-module-scss-module__D5qd8a__subtitle",
  "tagBlue": "ExploreRelatedProg-module-scss-module__D5qd8a__tagBlue",
  "tagGreen": "ExploreRelatedProg-module-scss-module__D5qd8a__tagGreen",
  "tags": "ExploreRelatedProg-module-scss-module__D5qd8a__tags",
  "title": "ExploreRelatedProg-module-scss-module__D5qd8a__title",
});
